import { CLOSE_ALERT } from 'action-types';

export default function () {
  return {
    type: CLOSE_ALERT,
  };
}
